<template>
  <ArticleThroughExperienceLayer v-if="experienceLayerIsEnabled" />
  <Article v-else />
</template>

<script lang="ts" setup>
import { useExperienceLayerIsEnabled } from '../../cms/composables/useExperienceLayerIsEnabled'

import Article from './Article.vue'
import ArticleThroughExperienceLayer from './ArticleThroughExperienceLayer.vue'

const experienceLayerIsEnabled = useExperienceLayerIsEnabled()
</script>
